export default "__VITE_ASSET__BfInwUKY__"